import React, { Component } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Button } from 'semantic-ui-react'
import { connectForm, ModalForm, Group, Form, Field, Submit, InfoGroup, Info } from '~/form'
import { editContact } from '../actions'
import ContactForm, { ContactFormValidations } from './form'
import moment from 'moment'

class ContactEdit extends Component {
  static formSubmit(dispatch, formId, values, changed) {
    dispatch(editContact(formId, values.get('id'), values.toJS()))
  }

  static formValidation = ContactFormValidations

  componentWillMount = () => {
    let { formInit, contact } = this.props
    formInit(contact)
  }

  render() {
    let { formUpdate, formSubmit, formState, formLoading, onClose, contact, types, typesLoading } = this.props

    let actions = (
      <Button
        size="tiny"
        color="green"
        content="Tallenna"
        onClick={e => e.preventDefault() & formSubmit()}
        icon="save"
      />
    )

    return (
      <ModalForm id="contact-edit" onSubmit={formSubmit} formState={formState} actions={actions} onClose={onClose}>
        <ContactForm {...this.props} title="Muokkaa yhteyshenkilöä" />
      </ModalForm>
    )
  }
}

function mapStateToProps(state) {
  return {}
}

function mapDispatchToProps(dispatch) {
  return {}
}

export default connectForm('contact-edit', ContactEdit, mapStateToProps, mapDispatchToProps)
